import React from 'react';
import { ListItemText } from '@mui/material';
import { MenuItem } from '../../MenuItem/MenuItem';
import Checkbox from '../../Checkbox/Checkbox';

function RoleMenuItem({ classes, disabled, checked, role, handleClick, getRoleLabel }) {
  return (
    <MenuItem
      value={role.uuid}
      disabled={disabled}
      onClick={() => handleClick(role.uuid)}
      className={classes.roleMenuItem}
      title={getRoleLabel(role.roleName)}
    >
      <Checkbox
        style={{ marginLeft: -2 }}
        sx={{
          color: 'white',
          '&.Mui-checked': { color: 'primary.main' },
        }}
        checked={checked}
      />
      <ListItemText
        classes={{
          primary: classes.listItemText,
          root: classes.listItemRoot,
        }}
        primary={getRoleLabel(role.roleName)}
      />
    </MenuItem>
  );
}

export default RoleMenuItem;
